<customer-selector #customerSelector [customerID]="customerID" (onChange)="customerSelectorChange($event)"
    [expand]="['SampleBooks', 'Locations', 'PrimaryContact']">
</customer-selector>
<div *ngIf="binders.order.customer">
    <mat-form-field appearance="fill" style="width:100%;">
        <mat-label>Customer Location</mat-label>
        <mat-select [(ngModel)]="shipToLocation" name="shipToLocation">
            <mat-option *ngFor="let loc of customerLocations" [value]="loc">
                <div class="customerLocation">
                    {{loc.LocationID}} - {{loc.LocationName}}<br />
                    {{loc.AddressLine1}}<br />
                    {{loc.City}}, {{loc.State}} {{loc.PostalCode}}
                </div>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- {{binders.order.customer?.CustomerName}}
    <div *ngIf="binders.order.shipToLocation">
        {{binders.order.shipToLocation.AddressLine1}}<br />
        <span
            *ngIf="binders.order.shipToLocation.AddressLine2">{{binders.order.shipToLocation.AddressLine2}}<br /></span>
        {{binders.order.shipToLocation.City}}, {{binders.order.shipToLocation.State}}
        {{binders.order.shipToLocation.PostalCode}}
    </div> -->
</div>

<mat-divider></mat-divider>

<table class="binder-list">
    <tr *ngFor="let binder of binders.Binders" class="binder-item">
        <td style="min-width:32px;">
            <mat-icon
                *ngIf="binder.UserAudited && binders.auditProgress(binder).audited > 0 && binders.auditProgress(binder).audited < binders.auditProgress(binder).total">
                checkmark</mat-icon>
            <mat-icon
                *ngIf="binder.UserAudited && binders.auditProgress(binder).audited == binders.auditProgress(binder).total">
                done_all</mat-icon>
        </td>
        <td style="width:100%;">
            <button mat-raised-button color="primary" class="binder-selection"
                [disabled]="binder.StockComponents.length == 0"
                (click)="gotoBinderAudit(binder.InventoryID!)">{{binder.Description}}</button>
        </td>
        <td class="binder-audit-progress">
            {{binderAuditProgress(binder)}}
        </td>
    </tr>
</table>

<mat-divider></mat-divider>

<button mat-raised-button color="primary" [disabled]="!shipToLocation" style="margin-top:0.5em; width: 95vw;"
    (click)="reviewAndPlace()">Continue</button>